import { FormattedMessage } from 'react-intl';
import {
    PoolButton,
    PoolModal,
    PoolModalActions,
    PoolModalContent,
    PoolModalTitle,
    PoolTextfield,
} from '@synergy/components-next';
import { useParams } from 'react-router-dom';
import { useState } from 'react';

import { bonusSettlementsSupplierDetailSelector } from '../store/bonus-settlements-supplier-detail-selector';
import { updateNoteFromSupplier } from '../store/bonus-settlements-supplier-detail-actions';
import { useAppSelector } from '../../../../store/use-appstate-selector';
import { useThunkDispatch } from '../../../../store/use-thunk-dispatch';

interface BonusSettlementSupplierDetailCommentModalProps {
    open: boolean;
    onClose: () => void;
    translationId: string;
}

export const BonusSettlementSupplierDetailCommentModal = (props: BonusSettlementSupplierDetailCommentModalProps) => {
    const { open, onClose, translationId } = props;
    const dispatch = useThunkDispatch();
    const bonusSettlementSupplierDetail = useAppSelector(bonusSettlementsSupplierDetailSelector);
    const { bonusSettlementId, id: supplierBonusSettlementId } = useParams<{ bonusSettlementId: string; id: string }>();
    const [comment, setComment] = useState<string>(bonusSettlementSupplierDetail?.noteFromSupplier ?? '');

    const handleSave = () => {
        if (bonusSettlementId && supplierBonusSettlementId) {
            dispatch(
                updateNoteFromSupplier({
                    bonusSettlementId: +bonusSettlementId,
                    supplierBonusSettlementId: +supplierBonusSettlementId,
                    noteFromSupplier: comment,
                })
            );
            onClose();
        }
    };

    const handleClose = () => {
        setComment(bonusSettlementSupplierDetail?.noteFromSupplier ?? '');
        onClose();
    };

    return (
        <PoolModal open={open} onClose={handleClose}>
            <PoolModalTitle>
                <FormattedMessage id={translationId} />
            </PoolModalTitle>
            <PoolModalContent>
                <PoolTextfield
                    value={comment}
                    onChange={e => setComment(e.target.value.slice(0, 400))}
                    label={<FormattedMessage id="app.bonusSettlements.supplierDetail.comment" />}
                    fullWidth={true}
                    multiline={true}
                    rows={3}
                    hint={
                        <FormattedMessage
                            id="app.common.characterLimit"
                            values={{ value: comment.length ?? 0, total: 400 }}
                        />
                    }
                    disabled={bonusSettlementSupplierDetail?.readOnly}
                />
            </PoolModalContent>
            <PoolModalActions>
                <PoolButton variant="outlined" onClick={handleClose}>
                    <FormattedMessage id="app.common.close" />
                </PoolButton>
                <PoolButton
                    onClick={handleSave}
                    disabled={bonusSettlementSupplierDetail?.readOnly || comment.length === 0}
                >
                    <FormattedMessage id="app.common.save" />
                </PoolButton>
            </PoolModalActions>
        </PoolModal>
    );
};
